<template>
    <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.0908 22.3877C19.0052 18.1236 20.8552 13.2003 21.4808 8.04393C21.5152 7.79084 21.6198 7.55302 21.7825 7.35849C21.9451 7.16396 22.159 7.02084 22.3988 6.94597C27.3508 5.3856 30.1658 7.86264 30.1188 13.5205C30.1098 14.6185 30.0598 15.5942 29.9538 17.0853C29.7168 20.4189 29.7358 21.3285 30.1028 21.9406C30.4548 22.5293 31.6028 22.73 34.3028 22.2064C35.1558 22.0414 36.0118 21.854 36.9608 21.63C37.3798 21.5281 40.3938 20.7815 41.1608 20.6114C42.2882 20.3185 43.4496 20.1832 44.6128 20.2091C47.1258 20.366 48.4588 22.0139 48.6888 25.1703C49.0948 30.7294 47.8408 41.8964 46.5888 46.0092C45.3168 50.2147 43.0908 51.8015 37.7368 51.8973C34.2968 51.9591 28.9968 51.9591 21.8368 51.8973C20.1299 51.8799 18.4438 51.5131 16.8788 50.8187C17.3052 49.9195 17.526 48.9337 17.5248 47.9352V26.5463C17.5272 25.034 17.0211 23.5664 16.0908 22.3877Z"
            :fill="color || '#EC4B1D'"
        />
        <path
            opacity="0.3"
            d="M8.2562 22.5323C7.20718 22.5277 6.19931 22.9476 5.45425 23.6998C4.7092 24.452 4.28797 25.4747 4.2832 26.5432L4.2832 47.9321C4.28504 48.4615 4.38928 48.9853 4.58997 49.4736C4.79067 49.962 5.08387 50.4052 5.45284 50.7781C5.82181 51.151 6.2593 51.4461 6.74032 51.6467C7.22133 51.8473 7.73644 51.9494 8.2562 51.9471H10.9042C11.9532 51.9517 12.9611 51.5317 13.7062 50.7796C14.4512 50.0274 14.8724 49.0046 14.8772 47.9362V26.5473C14.8754 26.0179 14.7711 25.494 14.5704 25.0057C14.3697 24.5174 14.0765 24.0741 13.7076 23.7012C13.3386 23.3284 12.9011 23.0332 12.4201 22.8326C11.9391 22.6321 11.424 22.53 10.9042 22.5323H8.2562Z"
            :fill="color || '#EC4B1D'"
        />
    </svg>
</template>
<script>
export default {
    name: "Like",
    props: ["color"],
};
</script>


// WEBPACK FOOTER //
// src/components/V2/svg/components/Like.vue